import React from 'react'
import PropTypes from 'prop-types'
import { connect as connectRedux } from 'react-redux'
import compose from 'recompose/compose'
import FormsyForm from 'formsy-react'
import { connect as connectStaticText } from '../StaticText/connect'
import { getBoundActions } from '../../actions/index'
import { get as getConfig } from '../../config/index'
import { setLocalStorage } from '../../services/local-preferences/index'
import { EmailInput, Checkbox } from '../FormInput.v2/index'
import { FORM_INPUT_NAME_EMAIL_OPT_IN } from '../../services/form/index'
import Button, { TYPES } from '../Button/index'
import { EMAIL_CAPTURED_GA4_EVENT } from '../../services/event-tracking/index'
import { buildGranularEmailPreferenceOptions } from '../../services/email-signup/index'

const { appLang } = getConfig()

class EmailCapture extends React.Component {
  static propTypes = {
    captureKey: PropTypes.string.isRequired,
  }

  constructor (props) {
    super(props)
    this.disableButton = this.disableButton.bind(this)
    this.enableButton = this.enableButton.bind(this)
    this.state = { canSubmit: false }
  }

  onSelectOptInCheckbox = (name, checked) => {
    const { setEmailSignupOptin } = this.props

    setEmailSignupOptin(checked)
  }

  onValidSubmit = (model) => {
    const { props } = this
    const {
      doEmailSignup,
      setEventDefault,
      url,
      utm,
      userLanguage,
      captureKey,
      auth,
      uid,
      uiLocation,
      emailSignup,
    } = props
    const { email } = model
    const source = ''
    const fields = {
      registration_language: userLanguage,
      url,
      form_name: 'GAIA_STREAM_LIVE_CHANNEL',
    }
    const emailOptIn = emailSignup.get('optIn', false)
    const emailPreferenceOptions = buildGranularEmailPreferenceOptions(emailOptIn)

    setLocalStorage(captureKey, 'yes', uid, auth)

    doEmailSignup(
      email,
      source,
      fields,
      utm,
      emailOptIn,
      false,
      '',
      emailPreferenceOptions,
    ).then((data) => {
      if (data && data.success) {
        const emailCapturedEventData = EMAIL_CAPTURED_GA4_EVENT
          .mergeDeep({
            ui_location: uiLocation,
          })

        setEventDefault(emailCapturedEventData)
      }
    })
  }

  disableButton () {
    this.setState({ canSubmit: false })
  }

  enableButton () {
    this.setState({ canSubmit: true })
  }

  renderForm = () => {
    const { props, state } = this
    const { staticText, email, emailSignup } = props
    const emailOptIn = emailSignup.get('optIn', false)
    const canSubmit = state.canSubmit && !!emailSignup.get('optIn')

    return (
      <FormsyForm
        className="live-channel-page__email-capture__form"
        onValidSubmit={this.onValidSubmit}
        onValid={this.enableButton}
        onInvalid={this.disableButton}
      >
        <EmailInput
          className={['live-channel-page__email-capture__form__input']}
          label={staticText.getIn(['data', 'email'])}
          name="email"
          value={email}
          validations="isEmail"
          validationError={staticText.getIn(['data', 'invalidEmail'])}
          required
        />
        <div className="live-channel-page__email-capture__checkbox-container">
          <Checkbox
            onChange={this.onSelectOptInCheckbox}
            name={FORM_INPUT_NAME_EMAIL_OPT_IN}
            label={staticText.getIn(['data', 'optIn'])}
            value={emailOptIn}
            className="live-channel-page__email-capture__optin"
            required
          />
        </div>
        <Button
          type={TYPES.PRIMARY}
          submit
          disabled={!canSubmit}
        >
          {staticText.getIn(['data', 'EmailSubmit'])}
        </Button>
      </FormsyForm>
    )
  }

  render () {
    const { props } = this
    const { staticText } = props

    return (
      <div>
        <div className="live-channel-page__email-capture__label">
          {staticText.getIn(['data', 'EmailLabel'])}
        </div>
        {this.renderForm()}
      </div>
    )
  }
}

EmailCapture.defaultProps = {
  uiLocation: 'Gaia Now',
}

export default compose(
  connectStaticText({ storeKey: 'liveChannelPage' }),
  connectRedux(
    (state) => ({
      auth: state.auth,
      uid: (state.auth) ? state.auth.get('uid') : -1,
      emailSignup: state.emailSignup,
      url: state.page.get('path'),
      utm: state.inboundTracking.getIn(['data', 'strings', 'utm']),
      userLanguage: state.user.getIn(['data', 'language', 0], appLang),
      email: state.user.getIn(['data', 'mail']),
    }),
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        doEmailSignup: actions.emailSignup.doEmailSignupBrooklyn,
        setEmailSignupOptin: actions.emailSignup.setEmailSignupOptin,
        setEventDefault: actions.eventTracking.setEventDefault,
      }
    },
  ),
)(EmailCapture)
